<template>
  <div class="base-question-page">
    <div class="content-box">
      <div class="box1 flex-row flex-wrap row-between">
        <div v-for="(item,index) of optionList" :key="index"
             :class="[selectValue===index?'item-box-active':'']" class="item-box mt11 flex-row row-center col-center" v-on:click="changeOption(index)">
          <div :class="[item.icon]" :style="{color:item.color}" class="iconfont"></div>
          <div style="font-size: 13px;color: #333333;margin-left: 4px">{{ item.name }}</div>
        </div>
        <div class="item-box1"></div>
        <div class="item-box1"></div>
        <div class="item-box1"></div>
      </div>
      <div class="box2" style="margin-top: 13px">
        <van-collapse v-model="activePanel">
          <van-collapse-item v-for="item in questionList" :key="item.id" :name="item.id">
            <template #title>
              <div class="flex-row col-center">
                <van-icon name="question-o" style="color: #999999;font-size: 20px"/>
                <span class="ml8">{{ item.title }}</span>
              </div>
            </template>
            <div>
              {{ item.answer }}
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      optionList: [
        {
          name: '物流',
          icon: 'icon-wuliuqiache',
          color: '#E1BF03'
        },
        {
          name: '订单',
          icon: 'icon-dingdan1',
          color: '#10A5A0'
        },
        {
          name: '电影票',
          icon: 'icon-dianyingpiao',
          color: '#E47848'
        },
        {
          name: '卡券',
          icon: 'icon-youhuijuan-xianxing',
          color: '#E44848'
        },
        {
          name: '退换',
          icon: 'icon-tui',
          color: '#32B16C'
        },
        {
          name: '售后',
          icon: 'icon-shouhou',
          color: '#0E8AE1'
        }
      ],
      questionList: [
        {
          id: 1,
          title: '问：如何修改收货地址？',
          answer: '答：下单后需要修改收货地址，先用账号登录京东，点击上\n' +
              '方"我的订单”；2 在全部订单列表中可以看到所购买过的订\n' +
              '单记录，在订单后面点击“订单详情”；3 打开订单详细情\n' +
              '况的页面，左边...'
        }
      ],
      selectValue: '',
      activePanel: []
    }
  },
  methods: {
    changeOption(e) {
      this.selectValue = e
    }
  }
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
